import { createAsyncThunk } from "@reduxjs/toolkit";
import { uploaderApi } from "../../api/uploaderApi";
import { AppDispatch, RootState } from "../store";
import { handleRequest } from "../utils/handleRequest";
import i18n from "../../i18n";

export const uploadServiceModuleIconThunk = createAsyncThunk<
  string | null,
    { serviceModuleId: number; file: File | null },
  { dispatch: AppDispatch; state: RootState }
>(
  "icons/uploadServiceModuleIcon",
    async ({ serviceModuleId, file }, { dispatch }) => {
    const result = await handleRequest(
      dispatch,
      "direct",
        () => uploaderApi.uploadServiceModuleIcon(serviceModuleId, file),
      i18n.t("requestMessage.serviceModuleIconUploaded")
    );
    return result.success() ? result.result : null;
  }
);

export const uploadActionModuleIconThunk = createAsyncThunk<
  string | null,
    { actionModuleId: number; file: File | null },
  { dispatch: AppDispatch; state: RootState }
>(
  "icons/uploadActionModuleIcon",
    async ({ actionModuleId, file }, { dispatch }) => {
    const result = await handleRequest(
      dispatch,
      "direct",
        () => uploaderApi.uploadActionModuleIcon(actionModuleId, file),
      i18n.t("requestMessage.actionModuleIconUploaded")
    );
    return result.success() ? result.result : null;
  }
);

export const uploadCalendarEventIconThunk = createAsyncThunk<
  string | null,
    { serviceModuleId: number; eventId: number; file: File | null },
  { dispatch: AppDispatch; state: RootState }
>(
  "icons/uploadCalendarEventIcon",
    async ({ serviceModuleId, eventId, file }, { dispatch }) => {
    const result = await handleRequest(
      dispatch,
      "direct",
        () => uploaderApi.uploadCalendarEventIcon(serviceModuleId, eventId, file),
      i18n.t("requestMessage.calendarEventIconUploaded")
    );
    return result.success() ? result.result : null;
  }
);